// import React from 'react';
// import Checkbox from '@mui/material/Checkbox';
// import './CheckBox.scss';
 
// const CustomCheckbox = ({onChange, checked=false, name}) => {
//   return (
//     <div className="checkbox-container">
//       <Checkbox className="custom-checkbox" id={name} checked={checked} name={name} onChange={(e)=>onChange(e,e.target.name)}/>
//     </div>
//   );
// };
 
// export default CustomCheckbox;

// MUI CHECK BOX COMPONENT  BACKUP ON 10-10-2025 

// import React from 'react';
// import Checkbox from '@mui/material/Checkbox';
// import './CheckBox.scss';

// const CustomCheckbox = ({ onChange, checked = false, name, colorClass = '' }) => {
//   return (
//     <div className={`checkbox-container ${colorClass}`}>
//       <Checkbox
//         className={`custom-checkbox ${colorClass}`}
//         id={name}
//         checked={checked}
//         name={name}
//         onChange={(e) => onChange(e, e.target.name)}
//       />
//     </div>
//   );
// };

// export default CustomCheckbox;

// NEW CHECK BOX COMPONENT STARTS HERE 
import React from 'react';
import './CheckBox.scss';

const CustomCheckbox = ({ onChange, checked = false, name, colorClass = '' }) => {
  return (
    <div className={`checkbox-container ${colorClass}`}>
      <label className="checkbox-label" htmlFor={name}>
        <input
          type="checkbox"
          id={name}
          name={name}
          checked={checked}
          onChange={(e) => onChange(e, e.target.name)}
        />
        <span className="custom-checkbox"></span>
      </label>
    </div>
  );
};

export default CustomCheckbox;

